// @ts-check
/**
 * Format a name into the first letter of first name + last name
 *
 * ie. Turn "Jack Cuthbert" into "J. Cuthbert"
 * @param {string} name
 */
const parseName = (name: string): string => {
  const [first, last] = name.split(" ");
  return `${first.charAt(0)}. ${last}`;
};

/**
 * Parse a JIRA key into a number
 *
 * ie. Turn "DEXUS-1234" into "1234"
 * @param {string} id
 */
const parseId = (id = ""): string => id.split("-")[1];

export { parseId, parseName };
